import { Card, CardBody, Typography } from "@material-tailwind/react";
import useTransactionApi from "../../../hooks/useTransactionApi";
import DefaultLoading from "../../../components/common/DefaultLoading";
import ErrorLoadingState from "../../../components/common/buttons/ErrorLoadingState";
import { formatDate } from "../../../utility";

export type TransactionType = "Credit" | "Debit";

interface TransactionTableProps {
  transactionType: TransactionType;
}

function TransactionTable({ transactionType }: TransactionTableProps) {
  const { data, isLoading: isLoadingTransaction, error } = useTransactionApi();

  if (isLoadingTransaction) {
    return <DefaultLoading />;
  }

  if (error) {
    return (
      <div>
        <ErrorLoadingState />
      </div>
    );
  }

  const transactionData = data?.data.data;
  return (
    <div className="lg:w-2/3 mx-auto">
      <Card placeholder={undefined}>
        <CardBody placeholder={undefined} id={transactionType}>
          <div className="flex justify-between mb-7 px-1">
            <Typography
              placeholder={undefined}
              className="font-semibold text-black"
            >
              Details
            </Typography>
            <Typography
              placeholder={undefined}
              className="font-semibold text-black"
            >
              Amount
            </Typography>
          </div>
          {transactionData!
            .filter((transaction) => {
              if (transactionType === "Credit") {
                return transaction.transType === "CR";
              } else if (transactionType === "Debit") {
                return transaction.transType !== "CR";
              }
              return false;
            })
            .map((transaction, index) => (
              <Card
                placeholder={undefined}
                className={`shadow-none mt-2 ${
                  index % 2 === 0 && "bg-[#F5F5F6]"
                }`}
              >
                <CardBody
                  placeholder={undefined}
                  className="flex justify-between items-center mt"
                >
                  <div className="text-left">
                    <Typography
                      placeholder={undefined}
                      className="font-medium text-black"
                    >
                      {transaction.transactionDesc === ""
                        ? "Boat Transaction"
                        : transaction.transactionDesc}
                    </Typography>
                    <Typography placeholder={undefined}>
                      {formatDate(transaction.createdOn)}
                    </Typography>
                  </div>
                  <Typography
                    placeholder={undefined}
                    className={`font-semibold ${
                      transactionType === "Credit"
                        ? "text-green-500 "
                        : "text-red-500"
                    }`}
                  >
                    N{transaction.amount}
                  </Typography>
                </CardBody>
              </Card>
            ))}
        </CardBody>
      </Card>
    </div>
  );
}

export default TransactionTable;
